import { Link } from 'react-router-dom';
import MetaTags from '@/components/MetaTags';
import { PAGE_META_DATA } from '@/constants/constants';

function Terms() {
  return (
    <div className='container mx-auto p-4 sm:px-0'>
      <MetaTags title={PAGE_META_DATA.terms.title} description={PAGE_META_DATA.terms.description} />

      <h3>TERMS BETWEEN EKLIPX AND END USERS</h3>
      <p>
        PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS SITE OR PURCHASING ANY RESEARCH MATERIALS
      </p>
      <ol className='list-decimal [counter-reset:section] mt-4'>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          What is the eklipX Research Platform and is it accessed?
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            This is a platform (referred to as the “eklipX Research Platform”) which is owned and operated by us,
            whereby you (as an end user) can purchase articles, podcasts and other types of media related to financial
            services (the “Research Materials”) from persons (the “Research Providers”) which make their Research
            Materials available to be purchased on the eklipX Research Platform.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The eklipX Research Platform is made available via eklipx.io. You require access to the internet to access
            the eklipX Research Platform via the website.
          </li>
        </ol>

        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          What is this document for?
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            This document sets out the terms and conditions of you accessing and using the eklipX Research Platform.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You agree to these terms when you tick the box confirming this when applying to us for an account as an end
            user on the eklipX Research Platform.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Who we are and how to contact us.
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We are eklipX Limited, being a company, incorporated in England with company number 14950181 and having our
            registered office at 1H Eardley Crescent, London, United Kingdom, SW5 9JS. Our business address is 14 Hay’s
            Mews, London, W1J 5PT.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The best ways to contact us is via email at support@eklipx.io
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          There are other policies that apply to you
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The following also apply to your use of the eklipX Research Platform: <br />
            (a) our privacy policy which is available at <a href='https://eklipX.io/privacy-policy/'>
              Privacy Policy
            </a>{' '}
            - see further clause 22 (How we may use your personal information).
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
          <span className='font-semibold'> We may make changes to these terms </span>
          <br />
          We may amend these terms from time to time. We shall provide you with one month’s notice before the changes
          come into force. If you do not agree to our proposed changes, then you are free to terminate your account with
          us before the changes come into force.
        </li>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
          <span className='font-semibold'> We may make changes to the eklipX Research Platform</span> <br />
          We are completely free to amend the eklipX Research Platform as we see fit from time to time.
        </li>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          We may suspend or withdraw the eklipX Research Platform
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The eklipX Research Platform is made available free of charge.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We do not guarantee that the eklipX Research Platform, or that any Research Materials or any other content,
            will always be available or be uninterrupted. We may suspend or withdraw or restrict the availability of all
            or any part of the eklipX Research Platform for business and operational reasons.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You are also responsible for ensuring that all persons who access the eklipX Research Platform through your
            internet connection are aware of these terms of use and other applicable terms and conditions, and that they
            comply with them.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
          <span className='font-semibold'>We may transfer this agreement to someone else</span> <br />
          We may transfer our rights and obligations under these terms to another organisation. We will always tell you
          in writing if this happens and we will ensure that the transfer will not affect your rights under the
          contract.
        </li>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          You must keep your account details safe
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You will need to create your own ‘eklipX Account’ and login details to utilise the eklipX Research Platform.
            The personal data you input to create your eklipX Account will be stored on our secure servers and will be
            processed in accordance with our <a href='https://eklipx.io/privacy-policy/'> privacy policy</a>. You can
            access your personal data at any time on the ‘eklipX Account’ section of the website.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You are responsible for keeping safe your username and password. You must not disclose your password to any
            third party, and to the extent permitted by law, you agree to accept responsibility for all activities that
            occur when someone has logged onto the eklipX Research Platform using your username and password.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You should take all necessary steps to ensure that your password is kept confidential and secure and should
            immediately notify us via email at support@eklipx.io if you know or suspect that your password has or might
            have become known to anyone else, or if the password is being, or is likely to be used in an unauthorised
            manner. This is notwithstanding your own obligation to immediately change your password.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You are responsible for ensuring that the details you provide us with are correct and complete, and for
            informing us of any changes to the information you have provided.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We have the right to disable your account or password, whether chosen by you or allocated by us, at any
            time, if in our reasonable opinion you have failed to comply with any of the provisions of these terms of
            use or we think that your account may have been hacked or may be likely to be hacked.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          How you may use material on the eklipX Research Platform
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We are the licensee of all intellectual property rights on the eklipX Research Platform, and in the material
            (including the Research Materials) published on it. Those works are protected by copyright laws and treaties
            around the world. All such rights are reserved.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            When you purchase Research Material via the eklipX Research Platform you will be granted a licence to be
            able to read the Research Material from the Research Provider in accordance with the Research Provider End
            User Terms. You can view the Research Provider End User Terms on the following{' '}
            <Link className='underline' to='user-research-provider-terms'>
              Research Provider End User Terms
            </Link>
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You must not modify the paper or digital copies of any materials (including Research Materials) in any way,
            and you must not use any illustrations, photographs, video or audio sequences or any graphics separately
            from any accompanying text.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The status of the Research Providers as the authors of content on the eklipX Research Platform must always
            be acknowledged.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You must not use, reproduce or resell any part of the content on the eklipX Research Platform without
            obtaining a licence to do so from us or our licensors.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you print off, copy or download any part of the eklipX Research Platform in breach of these terms of use,
            your right to use the eklipX Research Platform will cease immediately and you must, at our option, return or
            destroy any copies of the materials (including the Research Materials) you have made.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Do not rely on information on the eklipX Research Platform
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The content on the eklipX Research Platform is provided for general information only. It is not intended to
            amount to advice (including financial advice) on which you should rely. You should consider obtaining
            professional or specialist advice before taking, or refraining from, any action, on the basis of the content
            on the eklipX Research Platform.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Although we make reasonable efforts to update the information on the eklipX Research Platform, we make no
            representations, warranties or guarantees, whether express or implied, that the content on the eklipX
            Research Platform is accurate, complete or up to date.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          No text or data mining, or web scraping
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You shall not conduct, facilitate, authorise or permit any text or data mining or web scraping in relation
            to the eklipX Research Platform or any services provided via, or in relation to, the eklipX Research
            Platform. This includes using (or permitting, authorising or attempting the use of):
            <br /> (a) any &quot;robot&quot;, &quot;bot&quot;, &quot;spider&quot;, &quot;scraper&quot; or other
            automated device, program, tool, algorithm, code, process or methodology to access, obtain, copy, monitor or
            republish any portion of the site or any data, content, information or services accessed via the same.
            <br /> (b) any automated analytical technique aimed at analysing text and data in digital form to generate
            information which includes but is not limited to patterns, trends and correlations.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The provisions in this clause should be treated as an express reservation of our rights in this regard,
            including for the purposes of Article 4(3) of Digital Copyright Directive ((EU) 2019/790).
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            This clause shall not apply insofar as (but only to the extent that) we are unable to exclude or limit text
            or data mining or web scraping activity by contract under the laws which are applicable to us.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          We are not responsible for websites we link to
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Where the eklipX Research Platform contains links to other sites and resources provided by third parties,
            these links are provided for your information only. Such links should not be interpreted as approval by us
            of those linked websites or information you may obtain from them.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We have no control over the contents of those sites or resources.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Research Providers’ content is not approved by us
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The eklipX Research Platform includes Research Materials and descriptions of said Research Materials written
            and uploaded by Research Providers. These materials have not been verified by us. The views expressed by the
            Research Providers on the eklipX Research Platform do not represent our views or values.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          How to complain about or report content
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We take infringement of your intellectual property rights seriously. If you believe that your intellectually
            property rights (including, but not limited to, your rights in: copyright; trademark; design; and patent
            claims), have been infringed please submit a complaint via email to support@eklipx.io.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Your email must contain:
            <br /> (a) the URL within the website on which the allegedly infringing Research Material can be found;
            <br /> (b) a statement that your rights have been infringed and how;
            <br /> (c) contact details which eklipX can use to contact you, such as your complete name, address,
            telephone number and email address;
            <br /> (d) a statement supported by documentary evidence that the information in your notice is accurate and
            complete and that you are the holder of the respective Intellectual Property Rights or that you are
            authorized to act on behalf of the holder; and
            <br /> (e) a description of the Research Material or Research Materials which have been allegedly infringed,
            with a specification of the precise nature of that alleged infringement.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The information set out above must also be present in any email about alleged defamation. If you are
            emailing about an allegation of defamation, please send the email to support@eklipx.io.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Upon receipt of your complaint, we may take certain actions, including, forwarding the complaint to the
            Research Provider responsible for listing the Research Material and/or removing or blocking access to the
            Research Material.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            eklipX will not in any way whatsoever be a party to any dispute between the party that issued the notice and
            the other party.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you become aware of any material that is illegal or could comprise or be connected to child sexual abuse
            or exploitation or could comprise terrorist content or be connected to terrorism, please contact us
            immediately via email to support@eklipx.io.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            For all other general complaints please send your email to support@eklipx.io
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Our role
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The eklipX Research Platform allows Research Providers to list and sell their Research Materials to you. We
            are neither a buyer (you) nor the seller (Research Provider) of the Research Materials nor do we have any
            input into the content of the Research Materials. We act as the Research Provider&apos;s agent solely for
            the purpose of concluding the sales contract between the Research Provider and you whereby we shall collect
            money on behalf of the Research Provider. You paying us for Research Materials purchased on the eklipX
            Research Platform shall constitute you paying the relevant Research Providers. Consequently, when you
            purchase Research Material via the eklipX Research Platform, a contract will be formed between you and the
            relevant Research Provider. Please refer to our Research Provider End User terms (refer to link in section
            10.2). eklipX is not a party to this contract nor assumes any responsibility arising out of or in connection
            with it. The Research Provider is responsible for the sale of the Research Materials and for dealing with
            any claims or any other issue arising out of or in connection with the contract between you and them.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Payment for the Research Materials{' '}
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You can purchase Research Materials on the eklipX Research Platform.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You can purchase the Research Materials: <br />
            (a) on a pay-as-you-go model whereby you click and pay for the Research Materials you would like to
            purchase; <br />
            (b) on a subscription basis whereby you click and pay to subscribe to a specific Research Provider, who will
            upload an agreed number of articles on the eklipX Research Platform over a set period of time for the price
            displayed on the eklipX Research Platform.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you sign up to the subscription model, but subsequently fail to pay an amount owing when due, then we
            reserve the right to suspend your account.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If the Research Material is listed for free, you only need to have an ‘eklipX Account’ set up on the eklipX
            Research Platform to view this free Research Material.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We accept no liability regarding errors made by you when purchasing Research Materials, for instance,
            regarding the type of Research Material.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            It is not possible to cancel the purchase of any Research Material or to exchange one Research Material for
            another after you have agreed to purchase the Research Material.{' '}
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Viewing the Research Material
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Once you have paid for the Research Material on the Research Platform, the Research Material will be made
            available for you on the eklipX Research Platform.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The purchased Research Material will remain accessible to you on the eklipX Research’s Platform for 60 days
            from and including the date of purchase.{' '}
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Issues when Viewing Research Material
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you cannot view your purchased Research Material due to an issue with the eklipX Research platform,
            please email the eklipX team at support@eklipx.io
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You must include a short summary of the issue (with photographic evidence if possible) in your email to us.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We will then find an alternative way to send you the Research Material. One such method would be emailing
            the Research Material to the email address you have inputted in the ‘eklipX Account’ section of the eklipX
            Research platform.{' '}
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Our responsibility for loss or damage suffered by you
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Whether you are a consumer or a business user, we do not exclude or limit in any way our liability to you
            where it would be unlawful to do so. This includes liability for death or personal injury caused by our
            negligence or the negligence of our employees, agents or subcontractors and for fraud or fraudulent
            misrepresentation.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you are a business user: <br />
            (a) we exclude all implied conditions, warranties, representations or other terms that may apply to the
            eklipX Research Platform or any content on it. <br />
            (b) we will not be liable to you for any loss or damage, whether in contract, tort (including negligence),
            breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with: <br />
            (i) use of, or inability to use, the eklipX Research Platform; or <br />
            (ii) use of or reliance on any content displayed on the eklipX Research Platform. <br />
            (c) in particular, we will not be liable for: <br />
            (i) any losses you incur as a result of you placing reliance upon any Research Materials; <br />
            (ii) any loss of profits, sales, business, or revenue; <br />
            (iii) any loss resulting from trading; <br />
            (iv) business interruption; <br />
            (v) loss of anticipated savings; <br />
            (vi) loss of business opportunity, goodwill or reputation; or <br />
            (vii) any indirect or consequential loss or damage. <br />
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Events outside of our control
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We will not be liable or responsible for any failure to perform this agreement, or delay in performance of
            any of our obligations under this agreement that is caused by events outside of our reasonable control
            (‘Force Majeure Event’).
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            A Force Majeure Event shall include any act, event, non-happening, omission or accident beyond our
            reasonable control and shall include in particular (without limitation) the following: <br />
            (a) disturbances in the internet connection; <br />
            (b) hardware and software disruptions; <br />
            (c) disruptions in the telecommunications networks; <br />
            (d) disruption of the electricity supply; <br />
            (e) strikes, lock-outs or other industrial action; <br />
            (f) failures to perform by third parties hired by eklipX; <br />
            (g) civil commotion, riot, invasion, terrorist attack or threat of terrorist attack, war (whether declared
            or not) or threat or preparation for war’ <br />
            (h) fire, explosion, storm, flood, earthquake, subsidence, epidemic or other natural disaster; or <br />
            (i) the acts, decrees, legislation, regulations or restrictions of any government. <br />
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Our performance under this agreement is deemed to be suspended for the period that the Force Majeure Event
            continues, and we will have an extension of time for performance for the duration of that period.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We will use our reasonable endeavours to bring the Force Majeure Event to a close or to find a solution by
            which our obligations may be performed despite the Force Majeure Event.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          How we may use your personal information
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We will only use your personal information as set out in our privacy policy:{' '}
            <a href='https://eklipx.io/privacy-policy/'>Privacy Policy</a>
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Children
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We do not allow children to have an account on the eklipX Research Platform.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          We are not responsible for viruses and you must not introduce them
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We do not guarantee that the eklipX Research Platform will be secure or free from bugs or viruses.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You are responsible for configuring your information technology, computer programmes and platform to access
            the eklipX Research Platform. You should use your own virus protection software.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You must not misuse the eklipX Research Platform by knowingly introducing viruses, trojans, worms, logic
            bombs or other material that is malicious or technologically harmful. You must not attempt to gain
            unauthorised access to the eklipX Research Platform, the server on which the eklipX Research Platform is
            stored or any server, computer or database connected to the eklipX Research Platform. You must not attack
            the eklipX Research Platform via a denial-of-service attack or a distributed denial-of-service attack. By
            breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990. We will
            report any such breach to the relevant law enforcement authorities and we will co-operate with those
            authorities by disclosing your identity to them. In the event of such a breach, your right to use the eklipX
            Research Platform will cease immediately.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Which country&apos;s laws apply to any disputes?
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you are a consumer, please note that these terms of use, their subject matter and their formation, are
            governed by the law of England and Wales. You and we both agree that the courts of England and Wales will
            have exclusive jurisdiction except that if you are a resident of Northern Ireland you may also bring
            proceedings in Northern Ireland, and if you are resident of Scotland, you may also bring proceedings in
            Scotland.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you are a business, these terms of use, their subject matter and their formation (and any non-contractual
            disputes or claims) are governed by the law of England and Wales. We both agree to the exclusive
            jurisdiction of the courts of England and Wales.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
          <span className='font-semibold'>Our Logo </span> <br />
          You are not permitted to use this logo without our approval.{' '}
          <div className='bg-[#002327] px-2 w-20'>
            {' '}
            <img src='/eklipx-research-light.svg' alt='Eklpix Research Logo' width={80} height={80} />
          </div>
        </li>

        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          General
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If any part, term or provision of these terms of use is held to be illegal, invalid or otherwise
            unenforceable, the validity or enforceability of the remainder of these terms of use shall not be affected.
            Any failure or delay on our part to exercise or enforce any right in these terms of use does not waive our
            right to enforce such right.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Notwithstanding anything to the contrary contained in these terms of use, they shall not operate to confer
            any rights or benefits on any third parties.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Nothing in these terms shall create, or be deemed to create a partnership or the relationship of principal
            and agent between us and you.{' '}
          </li>
        </ol>
      </ol>
    </div>
  );
}

export default Terms;
